module.exports = __webpack_public_path__ + "static/media/parkering.2bc76e8e.png";